import React, { useCallback } from "react";
import { formatParameterNameWithShortname, formatSubsetLabel } from "../../../../../utils/Format";
import SubsetTypes from "../../../../../utils/SubsetTypes";
import IconButton from "../../../../Buttons/IconButton";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { TParameterSelection } from "../../../index";

interface Props {
  item: TParameterSelection;
  onRemove?: (item: TParameterSelection) => void;
}

const computeIndexKey = (item: TParameterSelection) => {
  return `${item.parameter.id}-${item.subset.id}`;
}

const SelectedParametersItem = (props: Props) => {
  const { item, onRemove } = props;
  const shouldRenderActions = Boolean(onRemove);

  const onItemRemove = useCallback(() => {
    onRemove?.(item);
  }, [item, onRemove]);

  return (
    <tr key={computeIndexKey(item)}>
      <td>{formatParameterNameWithShortname(item.parameter)}</td>
      <td>{formatSubsetLabel(item.subset)}</td>
      <td>{SubsetTypes.humanize(item.subset.type)}</td>
      {
        shouldRenderActions &&
        <td align="right">
          {
            onRemove &&
            <IconButton icon={faTrash} onClick={onItemRemove} variant="danger" title="Remove" />
          }
        </td>
      }
    </tr>
  )
}

export default SelectedParametersItem;
